/** https://stackoverflow.com/a/65225615/3670829 */
export function dateDiffInDays(first: Date, second: Date): number {
  return Math.floor((second.getTime() - first.getTime()) / 86400000);
}
